#import "./AssetFields.graphql"

mutation AssignAsset(
  $assetId: ID!
  $employeeId: ID
  $location: AssetLocationEnum
  $assignedOn: ISO8601Date
  $notes: String
) {
  assignAsset(
    input: {
      assetId: $assetId
      employeeId: $employeeId
      location: $location
      assignedOn: $assignedOn
      notes: $notes
    }
  ) {
    asset {
      ...AssetFields
    }
  }
}
